export default __webpack_public_path__ + "static/media/13.76482d49.png";